export const BOT_ROUTES = Object.freeze({
  BOT_SETTINGS: '/bot',
  CENTRAL_ROUTING: '/bot/central-routing',
  KEYWORDS: '/bot/keywords',
  ABANDONED_SCHEDULING: '/bot/abandoned-scheduling',
  CONVERSATIONAL_LANDING_PAGES: '/bot/conversational-landing-pages',
  SUPPORT: '/bot/support',
  CONVERSATION_RATINGS: '/bot/ratings',
})
